import { AVAILABLE_APPOINTMENT_TIMES } from 'consts';
import { optionMap } from '../supporting';

export const getAvailableHours = () =>
  optionMap(
    AVAILABLE_APPOINTMENT_TIMES,
    'from-time',
    'id',
    'time',
    'displayTime',
  );

export const getAppointmentsFromRange = (
  startTimeId,
  endTimeId,
  appointmentDate,
) => {
  const timesInRange = AVAILABLE_APPOINTMENT_TIMES.filter(
    appointmentTime =>
      appointmentTime.id >= startTimeId && appointmentTime.id <= endTimeId,
  );
  return timesInRange.map(value => `${appointmentDate}T${value.time}`);
};
export const mergeTimeslots = (newTimeslots, existingTimeslots) => {
  // validNewTimeSlots will only include time slots that are not already included for that particular date
  const validNewTimeSlots = newTimeslots.filter(
    timeSlot => !isTimeslotInArray(timeSlot, existingTimeslots),
  );
  return existingTimeslots.concat(validNewTimeSlots); //
};

const isTimeslotInArray = (timeslot, array) =>
  !!array.find(element => element === timeslot);
